const autoNgTemplateLoaderTemplate1 = require('./template.html');

angular.module('portainer.kubernetes').component('kubernetesResourcePoolIngressesDatatable', {
  templateUrl: autoNgTemplateLoaderTemplate1,
  controller: 'KubernetesResourcePoolIngressesDatatableController',
  bindings: {
    titleText: '@',
    titleIcon: '@',
    dataset: '<',
    tableKey: '@',
    orderBy: '@',
    reverseOrder: '<',
    refreshCallback: '<',
  },
});
